import get from 'lodash/get';

import {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from 'views/AddProduct/types';
import actionTypes from './types';

export default (state, action) => {
  switch (action.type) {
    case asyncActionTypeRequest(actionTypes.GET_SM_DOCUMENTS):
      return {
        ...state,
        documentTab: {
          ...state.documentTab,
          loading: true,
        },
      };

    case asyncActionTypeSuccess(actionTypes.GET_SM_DOCUMENTS):
      return {
        ...state,
        documentTab: {
          ...state.documentTab,
          data: get(action, 'response.data.list', []),
          total: get(action, 'response.data.pagination.total', 0),
          loading: false,
        },
      };
    case asyncActionTypeFailure(actionTypes.GET_SM_DOCUMENTS):
      return {
        ...state,
        documentTab: {
          ...state.documentTab,
          data: [],
          loading: false,
          error: get(action, 'error'),
        },
      };

    case actionTypes.UPDATE_SM_DOCUMENTS_PARAMS: {
      return {
        ...state,
        documentTab: {
          ...state.documentTab,
          loading: false,
          sorter: action.payload.sorter,
          filter: action.payload.filter,
          pagination: action.payload.pagination,
        },
      };
    }
    default:
      return state;
  }
};
